// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file contract.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContractStatus, ContractStatusJson, ContractType, ContractTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { File, FileJson, FileUpload, FileUploadJson } from "./file_upload_pb";
import { file_file_upload } from "./file_upload_pb";
import type { ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file contract.proto.
 */
export const file_contract: GenFile = /*@__PURE__*/
  fileDesc("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", [file_enums, file_file_upload, file_general, file_google_protobuf_struct, file_google_protobuf_timestamp, file_organization]);

/**
 * @generated from message raccoonai.Contract
 */
export type Contract = Message<"raccoonai.Contract"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required raccoonai.ContractType type = 3;
   */
  type: ContractType;

  /**
   * @generated from field: required string deal_number = 4 [json_name = "deal_number"];
   */
  dealNumber: string;

  /**
   * @generated from field: optional string name = 5;
   */
  name: string;

  /**
   * @generated from field: required uint64 service_provider_id = 6 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required uint64 target_organization_id = 7 [json_name = "target_organization_id"];
   */
  targetOrganizationId: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp start_at = 8 [json_name = "start_at"];
   */
  startAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp end_at = 9 [json_name = "end_at"];
   */
  endAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp signed_at = 10 [json_name = "signed_at"];
   */
  signedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 11 [json_name = "paid_at"];
   */
  paidAt?: Timestamp;

  /**
   * @generated from field: optional string contract_file_key = 12 [json_name = "contract_file_key"];
   */
  contractFileKey: string;

  /**
   * @generated from field: optional raccoonai.ContractStatus status = 13;
   */
  status: ContractStatus;

  /**
   * to be deprecated in favor of tariff_rate_by_job_type
   *
   * @generated from field: optional uint64 tariff = 14;
   */
  tariff: bigint;

  /**
   * @generated from field: optional uint64 rent_cost = 15 [json_name = "rent_cost"];
   */
  rentCost: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct tariff_rate_by_job_type = 16 [json_name = "tariff_rate_by_job_type"];
   */
  tariffRateByJobType?: JsonObject;

  /**
   * @generated from field: optional raccoonai.Organization service_provider = 17 [json_name = "service_provider"];
   */
  serviceProvider?: Organization;

  /**
   * @generated from field: repeated raccoonai.FileUpload file_uploads = 18 [json_name = "file_uploads"];
   */
  fileUploads: FileUpload[];

  /**
   * Set where the caller preloads TargetOrganization. On a BY_NORM contract this
   * is the client paying monthly_fee.
   *
   * @generated from field: optional raccoonai.Organization target_organization = 19 [json_name = "target_organization"];
   */
  targetOrganization?: Organization;

  /**
   * BY_NORM only: flat monthly charge. Not rent_cost, which is container rental.
   *
   * @generated from field: optional uint64 monthly_fee = 20 [json_name = "monthly_fee"];
   */
  monthlyFee: bigint;
};

/**
 * @generated from message raccoonai.Contract
 */
export type ContractJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required raccoonai.ContractType type = 3;
   */
  type?: ContractTypeJson;

  /**
   * @generated from field: required string deal_number = 4 [json_name = "deal_number"];
   */
  deal_number?: string;

  /**
   * @generated from field: optional string name = 5;
   */
  name?: string;

  /**
   * @generated from field: required uint64 service_provider_id = 6 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required uint64 target_organization_id = 7 [json_name = "target_organization_id"];
   */
  target_organization_id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp start_at = 8 [json_name = "start_at"];
   */
  start_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp end_at = 9 [json_name = "end_at"];
   */
  end_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp signed_at = 10 [json_name = "signed_at"];
   */
  signed_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 11 [json_name = "paid_at"];
   */
  paid_at?: TimestampJson;

  /**
   * @generated from field: optional string contract_file_key = 12 [json_name = "contract_file_key"];
   */
  contract_file_key?: string;

  /**
   * @generated from field: optional raccoonai.ContractStatus status = 13;
   */
  status?: ContractStatusJson;

  /**
   * to be deprecated in favor of tariff_rate_by_job_type
   *
   * @generated from field: optional uint64 tariff = 14;
   */
  tariff?: string;

  /**
   * @generated from field: optional uint64 rent_cost = 15 [json_name = "rent_cost"];
   */
  rent_cost?: string;

  /**
   * @generated from field: optional google.protobuf.Struct tariff_rate_by_job_type = 16 [json_name = "tariff_rate_by_job_type"];
   */
  tariff_rate_by_job_type?: StructJson;

  /**
   * @generated from field: optional raccoonai.Organization service_provider = 17 [json_name = "service_provider"];
   */
  service_provider?: OrganizationJson;

  /**
   * @generated from field: repeated raccoonai.FileUpload file_uploads = 18 [json_name = "file_uploads"];
   */
  file_uploads?: FileUploadJson[];

  /**
   * Set where the caller preloads TargetOrganization. On a BY_NORM contract this
   * is the client paying monthly_fee.
   *
   * @generated from field: optional raccoonai.Organization target_organization = 19 [json_name = "target_organization"];
   */
  target_organization?: OrganizationJson;

  /**
   * BY_NORM only: flat monthly charge. Not rent_cost, which is container rental.
   *
   * @generated from field: optional uint64 monthly_fee = 20 [json_name = "monthly_fee"];
   */
  monthly_fee?: string;
};

/**
 * Describes the message raccoonai.Contract.
 * Use `create(ContractSchema)` to create a new message.
 */
export const ContractSchema: GenMessage<Contract, {jsonType: ContractJson}> = /*@__PURE__*/
  messageDesc(file_contract, 0);

/**
 * @generated from message raccoonai.ContractCreate
 */
export type ContractCreate = Message<"raccoonai.ContractCreate"> & {
  /**
   * @generated from field: required string deal_number = 1 [json_name = "deal_number"];
   */
  dealNumber: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional raccoonai.ContractType type = 3;
   */
  type: ContractType;

  /**
   * @generated from field: required uint64 service_provider_id = 4 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required uint64 target_organization_id = 5 [json_name = "target_organization_id"];
   */
  targetOrganizationId: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp start_at = 6 [json_name = "start_at"];
   */
  startAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp end_at = 7 [json_name = "end_at"];
   */
  endAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp signed_at = 8 [json_name = "signed_at"];
   */
  signedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 9 [json_name = "paid_at"];
   */
  paidAt?: Timestamp;

  /**
   * to be deprecated
   *
   * @generated from field: optional string contract_file_key = 10 [json_name = "contract_file_key"];
   */
  contractFileKey: string;

  /**
   * to be deprecated in favor of tariff_rate_by_job_type
   *
   * @generated from field: optional uint64 tariff = 11;
   */
  tariff: bigint;

  /**
   * @generated from field: optional uint64 rent_cost = 12 [json_name = "rent_cost"];
   */
  rentCost: bigint;

  /**
   * @generated from field: optional raccoonai.ContractStatus status = 13;
   */
  status: ContractStatus;

  /**
   * @generated from field: optional google.protobuf.Struct tariff_rate_by_job_type = 14 [json_name = "tariff_rate_by_job_type"];
   */
  tariffRateByJobType?: JsonObject;

  /**
   * @generated from field: optional raccoonai.File file = 15;
   */
  file?: File;

  /**
   * BY_NORM only
   *
   * @generated from field: optional uint64 monthly_fee = 16 [json_name = "monthly_fee"];
   */
  monthlyFee: bigint;
};

/**
 * @generated from message raccoonai.ContractCreate
 */
export type ContractCreateJson = {
  /**
   * @generated from field: required string deal_number = 1 [json_name = "deal_number"];
   */
  deal_number?: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional raccoonai.ContractType type = 3;
   */
  type?: ContractTypeJson;

  /**
   * @generated from field: required uint64 service_provider_id = 4 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required uint64 target_organization_id = 5 [json_name = "target_organization_id"];
   */
  target_organization_id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp start_at = 6 [json_name = "start_at"];
   */
  start_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp end_at = 7 [json_name = "end_at"];
   */
  end_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp signed_at = 8 [json_name = "signed_at"];
   */
  signed_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 9 [json_name = "paid_at"];
   */
  paid_at?: TimestampJson;

  /**
   * to be deprecated
   *
   * @generated from field: optional string contract_file_key = 10 [json_name = "contract_file_key"];
   */
  contract_file_key?: string;

  /**
   * to be deprecated in favor of tariff_rate_by_job_type
   *
   * @generated from field: optional uint64 tariff = 11;
   */
  tariff?: string;

  /**
   * @generated from field: optional uint64 rent_cost = 12 [json_name = "rent_cost"];
   */
  rent_cost?: string;

  /**
   * @generated from field: optional raccoonai.ContractStatus status = 13;
   */
  status?: ContractStatusJson;

  /**
   * @generated from field: optional google.protobuf.Struct tariff_rate_by_job_type = 14 [json_name = "tariff_rate_by_job_type"];
   */
  tariff_rate_by_job_type?: StructJson;

  /**
   * @generated from field: optional raccoonai.File file = 15;
   */
  file?: FileJson;

  /**
   * BY_NORM only
   *
   * @generated from field: optional uint64 monthly_fee = 16 [json_name = "monthly_fee"];
   */
  monthly_fee?: string;
};

/**
 * Describes the message raccoonai.ContractCreate.
 * Use `create(ContractCreateSchema)` to create a new message.
 */
export const ContractCreateSchema: GenMessage<ContractCreate, {jsonType: ContractCreateJson}> = /*@__PURE__*/
  messageDesc(file_contract, 1);

/**
 * @generated from message raccoonai.ContractUpdate
 */
export type ContractUpdate = Message<"raccoonai.ContractUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string deal_number = 2 [json_name = "deal_number"];
   */
  dealNumber: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 service_provider_id = 4 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 target_organization_id = 5 [json_name = "target_organization_id"];
   */
  targetOrganizationId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp start_at = 6 [json_name = "start_at"];
   */
  startAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_at = 7 [json_name = "end_at"];
   */
  endAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp signed_at = 8 [json_name = "signed_at"];
   */
  signedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 9 [json_name = "paid_at"];
   */
  paidAt?: Timestamp;

  /**
   * to be deprecated
   *
   * @generated from field: optional string contract_file_key = 10 [json_name = "contract_file_key"];
   */
  contractFileKey: string;

  /**
   * @generated from field: optional raccoonai.ContractStatus status = 11;
   */
  status: ContractStatus;

  /**
   * to be deprecated in favor of tariff_rate_by_job_type
   *
   * @generated from field: optional uint64 tariff = 12;
   */
  tariff: bigint;

  /**
   * @generated from field: optional uint64 rent_cost = 13 [json_name = "rent_cost"];
   */
  rentCost: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct tariff_rate_by_job_type = 14 [json_name = "tariff_rate_by_job_type"];
   */
  tariffRateByJobType?: JsonObject;

  /**
   * @generated from field: optional raccoonai.File file = 15;
   */
  file?: File;

  /**
   * BY_NORM only
   *
   * @generated from field: optional uint64 monthly_fee = 16 [json_name = "monthly_fee"];
   */
  monthlyFee: bigint;
};

/**
 * @generated from message raccoonai.ContractUpdate
 */
export type ContractUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string deal_number = 2 [json_name = "deal_number"];
   */
  deal_number?: string;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 service_provider_id = 4 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 target_organization_id = 5 [json_name = "target_organization_id"];
   */
  target_organization_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp start_at = 6 [json_name = "start_at"];
   */
  start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp end_at = 7 [json_name = "end_at"];
   */
  end_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp signed_at = 8 [json_name = "signed_at"];
   */
  signed_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 9 [json_name = "paid_at"];
   */
  paid_at?: TimestampJson;

  /**
   * to be deprecated
   *
   * @generated from field: optional string contract_file_key = 10 [json_name = "contract_file_key"];
   */
  contract_file_key?: string;

  /**
   * @generated from field: optional raccoonai.ContractStatus status = 11;
   */
  status?: ContractStatusJson;

  /**
   * to be deprecated in favor of tariff_rate_by_job_type
   *
   * @generated from field: optional uint64 tariff = 12;
   */
  tariff?: string;

  /**
   * @generated from field: optional uint64 rent_cost = 13 [json_name = "rent_cost"];
   */
  rent_cost?: string;

  /**
   * @generated from field: optional google.protobuf.Struct tariff_rate_by_job_type = 14 [json_name = "tariff_rate_by_job_type"];
   */
  tariff_rate_by_job_type?: StructJson;

  /**
   * @generated from field: optional raccoonai.File file = 15;
   */
  file?: FileJson;

  /**
   * BY_NORM only
   *
   * @generated from field: optional uint64 monthly_fee = 16 [json_name = "monthly_fee"];
   */
  monthly_fee?: string;
};

/**
 * Describes the message raccoonai.ContractUpdate.
 * Use `create(ContractUpdateSchema)` to create a new message.
 */
export const ContractUpdateSchema: GenMessage<ContractUpdate, {jsonType: ContractUpdateJson}> = /*@__PURE__*/
  messageDesc(file_contract, 2);

/**
 * @generated from message raccoonai.ContractList
 */
export type ContractList = Message<"raccoonai.ContractList"> & {
  /**
   * @generated from field: repeated raccoonai.Contract contracts = 1;
   */
  contracts: Contract[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.ContractList
 */
export type ContractListJson = {
  /**
   * @generated from field: repeated raccoonai.Contract contracts = 1;
   */
  contracts?: ContractJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.ContractList.
 * Use `create(ContractListSchema)` to create a new message.
 */
export const ContractListSchema: GenMessage<ContractList, {jsonType: ContractListJson}> = /*@__PURE__*/
  messageDesc(file_contract, 3);

